import React, { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import './navbar.styles.scss'
import useAuth from '../../hooks/useAuth'
import { signOutUser, successToast } from '../../utils/firebase/firebase.utils'
import { useNavigate } from 'react-router-dom'
import { FaOutdent } from 'react-icons/fa6'
import { BsBullseye, BsCaretRight, BsCaretRightFill } from 'react-icons/bs'
// import siteLogo from '../../assets/images/cakeIcon.png'
import {
  Navbar,
  Collapse,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import {
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import {
  Bars4Icon,
  GlobeAmericasIcon,
  NewspaperIcon,
  PhoneIcon,
  RectangleGroupIcon,
  SquaresPlusIcon,
  SunIcon,
  TagIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid";
import { LiaUserEditSolid } from 'react-icons/lia'
import { LuFilePen } from 'react-icons/lu'
import { PiDotDuotone } from 'react-icons/pi'

const navigation = [
  // { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
//   { name: 'Gallery', href: '/gallery' },
  { name: 'Contact', href: '/#contact' },
  // { name: 'Book', href: '/book' },
]

const navListMenuItems = [
    {
      title: "Interpreting Services",
      description: "Virtual & In-person interpretation",
      icon: LiaUserEditSolid,
      urlto: "/services/interpretation"
    },
    {
      title: "Translation",
      description: "Document translation (business, legal...)",
      icon: LuFilePen,
      urlto: "/services/translation"
    },
];
 
function NavListMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const renderItems = navListMenuItems.map(
    ({ icon, title, description, urlto }, key) => (
      <a href={urlto} key={key} className=''>
        <MenuItem className="flex items-center gap-3 rounded-lg">
          <div className="flex items-center justify-center rounded-lg !bg-blue-gray-50 p-2 ">
            {" "}
            {React.createElement(icon, {
              strokeWidth: 2,
              className: "h-6 text-gray-900 w-6",
            })}
          </div>
          <div>
            <Typography
              variant="h6"
              color="blue-gray"
              className="flex items-center text-sm font-bold"
            >
              {title}
            </Typography>
            <Typography
              variant="paragraph"
              className="text-xs !font-medium text-blue-gray-500"
            >
              {description}
            </Typography>
          </div>
        </MenuItem>
      </a>
    ),
  );
 
  return (
    <React.Fragment>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        offset={{ mainAxis: 20 }}
        placement="bottom"
        allowHover={true}
      >
        <MenuHandler className=''>
        {/* className="text-xs font-semibold uppercase tracking-wider leading-6 p-1.5 text-gray-900 hover:opacity-70 hover:border-b-violet-800 border-2 border-white/0 px-6" */}
          <a className='' >
            <ListItem
              className="flex items-center gap-2 bg-[#0000] uppercase text-xs font-semibold text-gray-900 tracking-wider"
              selected={isMenuOpen || isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((cur) => !cur)}
            >
              Services
              <ChevronDownIcon
                strokeWidth={2.5}
                className={`hidden h-3 w-3 transition-transform lg:block ${
                  isMenuOpen ? "rotate-180" : ""
                }`}
              />
              <ChevronDownIcon
                strokeWidth={2.5}
                className={`block h-3 w-3 transition-transform lg:hidden ${
                  isMobileMenuOpen ? "rotate-180" : ""
                }`}
              />
            </ListItem>
          </a>
        </MenuHandler>
        <MenuList className="hidden max-w-screen-xl rounded-xl lg:block">
          <ul className="grid grid-cols-2 gap-y-2 outline-none outline-0">
            {renderItems}
          </ul>
        </MenuList>
      </Menu>
      <div className="block lg:hidden">
        <Collapse open={isMobileMenuOpen}>{renderItems}</Collapse>
      </div>
    </React.Fragment>
  );
}




export default function Navbar1() {

  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { currentUser, setCurrentUser } = useAuth();


  const signOutHandler = async () => {
    await signOutUser();
    setCurrentUser(null);
    successToast('Logout Successful..!');

    localStorage.setItem('curUser', '');
    navigate('/');
    // console.log(localStorage.getItem('curUser'));
  }

  return (
    <header className="absolute inset-x-0 top-0 z-50 h-20 shadow-md">
        <nav className="flex items-center justify-between px-6 pt-6 pb-4 lg:px-8 bg-white/80" aria-label="Global">
            <div className="flex lg:flex-1">
                <a href="/" className="-m-1.5 p-1.5">
                    <span className="sr-only">Your Company</span>
                    <img
                    className="h-9 mt-1 w-auto"
                    src="https://firebasestorage.googleapis.com/v0/b/cakebysandy-a4e24.appspot.com/o/files%2FlangH_logo_redo_blue_%23333652.png?alt=media&token=f0d98403-857a-40c1-994b-722a73efe321"
                    alt=""
                    />
                </a>
                <div className='px-3 pt-1.5'>
                    <p className='font-bold uppercase leading-4 text-gray-900/90'>Language</p>
                    <p className='text-xs tracking-widest uppercase'>Helpers LLC</p>
                </div>
                {/* <h2 className='text-logo'>Cake by Sandy</h2> */}
            </div>
            
            <div className="flex lg:hidden">
            <button
                type="button"
                className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(true)}
            >
                <span className="sr-only">Open main menu</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
            </div>
            
            <div className="hidden lg:flex lg:flex-1 lg:justify-end">

                <div className="hidden lg:flex lg:gap-x-1 text-right mr-5">
                <a href="/" className="text-xs font-semibold uppercase tracking-wider leading-6 p-1.5 text-gray-900 hover:opacity-70 hover:border-b-violet-800 border-2 border-white/0 px-6">
                  Home
                </a>
                <NavListMenu />
                {navigation.map((item) => (
                    <a key={item.name} href={item.href} className="text-xs font-semibold uppercase tracking-wider leading-6 p-1.5 text-gray-900 hover:opacity-70 hover:border-b-violet-800 border-2 border-white/0 px-6">
                    {item.name}
                    </a>
                ))}
                </div>

                { currentUser ?
                <>
                    <a href='/manage' className="rounded-md h-9 bg-violet-500 px-3.5 py-2 mx-1 text-sm font-medium text-white shadow-sm hover:bg-violet-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500">
                        Manage
                    </a>
                    <a onClick={signOutHandler} className="rounded-md h-9 bg-blue-gray-900 px-3.5 py-2 text-sm font-medium text-white shadow-sm hover:opacity-90">
                        Logout
                    </a>
                </>
                :
                  <a href='/manage' className="rounded-md h-9 bg-gray-900/90 px-3.5 py-2 mx-1 text-sm font-medium text-white shadow-sm hover:bg-gray-700/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500">
                      Login  <span aria-hidden="true">&rarr;</span>
                  </a>
                }
            </div>
        </nav>

        <Dialog className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
            <div className="fixed inset-0 z-50" />
            <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <img
                  className="h-8 mt-1.5 w-auto"
                  // src={siteLogo}
                  src="https://firebasestorage.googleapis.com/v0/b/cakebysandy-a4e24.appspot.com/o/files%2FlangH_logo_redo_blue_%23333652.png?alt=media&token=f0d98403-857a-40c1-994b-722a73efe321"
                  alt=""
                />
              </a>
              <div className='px-3 pt-1.5'>
                  <p className='font-bold uppercase leading-4 text-gray-900/90'>Language</p>
                  <p className='text-xs tracking-widest uppercase'>Helpers LLC</p>
              </div>
              </div>
              <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
              >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
                <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  <a href="/" className="-mx-3 block rounded-lg bg-violet-300/10 px-3 py-2 text-sm font-normal uppercase tracking-wider leading-7 text-gray-900 hover:bg-gray-50">
                    <PiDotDuotone className='mt-1.5 mr-3 float-left' /> Home
                  </a>
                  <a href="/services/interpretation" className="-mx-3 block rounded-lg bg-violet-300/10 px-3 py-2 text-sm font-normal uppercase tracking-wider leading-7 text-gray-900 hover:bg-gray-50">
                    <PiDotDuotone className='mt-1.5 mr-3 float-left' /> Services
                  </a>
                  {navigation.map((item) => (
                  <a key={item.name} href={item.href} className="-mx-3 block rounded-lg bg-violet-300/10 px-3 py-2 text-sm font-normal uppercase tracking-wider leading-7 text-gray-900 hover:bg-gray-50">
                      <PiDotDuotone className='mt-1.5 mr-3 float-left' />
                      {item.name}
                  </a>
                  ))}
                </div>
                <div className="py-6">
                    { currentUser ?
                    <a onClick={signOutHandler} className="rounded-md bg-blue-gray-900 px-3.5 py-2 text-sm uppercase font-semibold text-white shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500"
                    >
                        Logout
                    </a>
                    :
                    // <a href="/manage" 
                    // className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                    // >
                    // Log in
                    // </a>
                    <a href='/manage' className="rounded-md h-9 bg-blue-gray-800 px-5 py-2 m-auto text-sm font-medium uppercase text-white shadow-sm hover:bg-blue-gray-700">
                        Login
                    </a>
                    }
                </div>
                </div>
            </div>
            </DialogPanel>
        </Dialog>
    </header>
  )
}
